// removed by extract-text-webpack-plugin
module.exports = {"overlay":"Overlay__overlay--sA81s"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Library/Overlay/Overlay.css
// module id = ./src/components/Library/Overlay/Overlay.css
// module chunks = 2